'use client';

import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { SEARCH_MODAL_HASH } from '@/components/constants';
import { checkIsHashActive } from '@/utils/check-is-hash-active';
import { useRouteHash } from '@/utils/use-route-hash';
interface SearchContextValue {
  isOpen: boolean;
  open: () => void;
  close: (isHashRemove?: boolean) => void;
}
const SearchContext = createContext<SearchContextValue | null>(null);
export function useSearchModal() {
  const ctx = useContext(SearchContext);
  if (!ctx) throw new Error('useSearchModal must be used inside SearchModalProvider');
  return ctx;
}
export function SearchModalProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const onHashRemoved = useCallback(() => setIsOpen(false), []);
  const {
    addHash,
    removeHash
  } = useRouteHash({
    hash: SEARCH_MODAL_HASH,
    replace: false,
    onHashRemoved
  });
  const open = useCallback(() => {
    try {
      // @ts-expect-error: Goftino doesn't include types
      Goftino.close();
    } catch {
      // nothing
    }
    setIsOpen(true);
    addHash();
  }, [addHash]);
  const close = useCallback((isRemoveHash = true) => {
    setIsOpen(false);
    if (isRemoveHash) removeHash();
  }, [removeHash]);
  useEffect(() => {
    return () => {
      setIsOpen(false);
    };
  }, []);
  useEffect(() => {
    const isHashActive = checkIsHashActive(SEARCH_MODAL_HASH);
    if (isHashActive) {
      window.history.replaceState(window.history.state, '', window.location.pathname + window.location.search);
    }
  }, []);
  return <SearchContext.Provider value={{
    isOpen,
    open,
    close
  }} data-sentry-element="unknown" data-sentry-component="SearchModalProvider" data-sentry-source-file="search-modal-context.tsx">{children}</SearchContext.Provider>;
}